/* global jQuery COMPONENTS */

COMPONENTS.ComponentBlog = (function ($) {
  function ComponentBlog () {
    this.$component = $('[data-ecs-component="component-blog"]')
    this.$blogGrid = this.$component.find('[data-ecs-components-blog-grid]')
    this.$blogItems = this.$blogGrid.find('[data-ecs-components-control="blog-article"]')
    this.$loadMore = this.$component.find('[data-ecs-components-control="load-more"]')

    this.$blogParams = this.$component.find('[data-ecs-components-control="blog-params"]')

    this.nextPage = this.$blogParams.data('ecs-components-blog-current-page')
    this.maxPages = this.$blogParams.data('ecs-components-blog-max-pages')
    this.query = this.$blogParams.data('ecs-components-blog-query')
    this.index = this.$blogParams.data('ecs-components-blog-index')
    this.postsPerPage = this.$blogParams.data('ecs-components-blog-posts-per-page')

    this.$filters = $('[data-ecs-components-control="filter-blog-category"]')

    this.pageID = this.$blogGrid.data('ecs-components-page-id')
  }

  ComponentBlog.prototype.calcCardHeights = function (grid) {
    if (typeof grid == 'undefined') {
      console.log('Blog grid not found, exiting...')
      return;
    }

    const $blogItems = $(grid).find('[data-ecs-components-control="blog-article"]')
    let tallestCardHeight = 0
    const viewportTablet = $(window).width() >= 769

    $blogItems.each(function () {
      const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
      cardWrap.css('min-height', '')
    })

    // Loop over the article cards to find the card with the greatest height
    $blogItems.each(function () {
      const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
      tallestCardHeight = Math.max(tallestCardHeight, cardWrap.outerHeight())
    })

    // Test if viewport is tablet or greater
    if (viewportTablet) { // Tablet or above
      $blogItems.each(function () {
        const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
        cardWrap.css('min-height', (tallestCardHeight + 'px'))
      })
    } else { // Mobile
      $blogItems.each(function () {
        const cardWrap = $(this).children('.ecs__component-blog__card__wrap')
        cardWrap.css('min-height', '')
      })
    }

    $(grid).isotope('layout')
  }

  ComponentBlog.prototype.initGrid = function () {
    if (this.$blogGrid.length < 1) {
      return false
    }

    this.$blogGrid.each(function () {
      const $grid = $(this)

      $grid.imagesLoaded(function () {
        $grid.isotope({
          itemSelector: '[data-ecs-components-control="blog-article"]',
          layoutMode: 'masonry'
        })
      })
    })
  }

  ComponentBlog.prototype.initLoadMore = function () {
    if (this.$loadMore.length < 1) {
      return false
    }

    const component = this

    this.$loadMore.click(function (e) {
      e.preventDefault()

      // Don't try to load if we are already loading
      if (component.$loadMore.hasClass('loading')) {
        return false
      }

      // Don't try to load if we are already at the max number of pages
      if (component.nextPage > component.maxPages) {
        return false
      }

      component.getArticles()
    })
  }

  ComponentBlog.prototype.initFilters = function () {
    if (this.$filters.length < 1) {
      return false
    }

    const component = this

    component.$filters.each(function () {
      const $filter = $(this)

      $filter.click(function () {
        component.$filters.each(function () {
          $(this).removeClass('components__active')
        })

        $filter.addClass('components__active')

        const filterCategory = $(this).data('ecs-filter-blog-category')

        if (filterCategory !== '*') {
          component.query.tax_query = [{
            taxonomy: 'category', field: 'term_id', terms: [filterCategory]
          }]
        } else {
          component.query.tax_query = []
        }

        component.$blogGrid.isotope('remove', component.$blogGrid.isotope('getItemElements'))
        component.nextPage = 1
        component.getArticles()
      })
    })
  }

  ComponentBlog.prototype.getArticles = function () {
    const component = this

    component.$loadMore.addClass('loading')

    component.query.posts_per_page = component.postsPerPage

    if (component.postsPerPage) {

    }

    const requestArray = {
      action: 'component_blog_load_more_posts',
      query: component.query,
      page: component.nextPage,
      pages: component.maxPages,
      page_id: component.pageID,
      index: component.index
    }

    $.post(COMPONENTS.ajaxURL, requestArray).done(function (_data) {
      if (_data) {
        component.injectArticles(_data)
      }
    })
  }

  ComponentBlog.prototype.injectArticles = function (_data) {
    const component = this
    const data = JSON.parse(_data)

    for (let i = 0; i < data.articles.length; i++) {
      const $item = $(data.articles[i])
      component.$blogGrid.append($item).isotope('appended', $item)
    }

    component.$blogGrid.imagesLoaded().done(function () {
      // FIXME: There is a race condition happening here
      // I've added a setTimeout (250ms) to resolve, for now
      setTimeout(function () {
        component.calcCardHeights(component.$blogGrid)
      }, 250)
    })

    component.nextPage = parseInt(component.nextPage + 1)
    component.maxPages = parseInt(data.max_pages)

    if (component.nextPage > component.maxPages) {
      component.$loadMore.hide()
    } else {
      component.$loadMore.show()
    }

    component.$loadMore.removeClass('loading')
  }

  // Init the Blog Component
  ComponentBlog.prototype.init = function () {
    const component = this

    this.initGrid()
    $(window).on('resize', function () {
      component.calcCardHeights(component.$blogGrid)
    })

    component.$blogGrid.imagesLoaded().done(function () {
      // FIXME: There is a race condition happening here
      // I've added a setTimeout (250ms) to resolve, for now
      setTimeout(function () {
        component.calcCardHeights(component.$blogGrid)
      }, 250)
    })

    this.initLoadMore()
    this.initFilters()
  }

  return ComponentBlog
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Test if the page requires scripts for the Blog Component,
  // Hook into the main components init
  if (pageComponentsList.includes('component-blog')) {
    COMPONENTS.componentBlog = new COMPONENTS.ComponentBlog()
    COMPONENTS.componentBlog.init()
  }
})
